module.exports = __webpack_public_path__ + "static/media/onlineteacher4.c46b2fe0.PNG";